import { createStyles, Theme } from '@material-ui/core/styles';

import { colours } from '@shared/theme/colours';

export const styles = ({ spacing, breakpoints }: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      gap: spacing(3),
      padding: spacing(6),
      overflow: 'auto !important',
    },
    header: {
      alignSelf: 'stretch',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      gap: 8,
    },
    headerTitleContainer: {
      alignSelf: 'stretch',
      display: 'flex',
      justifyContent: 'flex-start',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 20,
    },
    headerTitleRow: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
    },
    headerIcon: {
      width: 20,
      height: 20,
      color: colours.neutral[500],
    },
    title: {
      color: colours.neutral[900],
      fontSize: 18,
      fontFamily: 'Inter',
      fontWeight: 600,
      lineHeight: '28px',
      margin: 0,
      wordWrap: 'break-word',
    },
    benefitsList: {
      alignSelf: 'stretch',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      gap: 8,
    },
    benefitItem: {
      alignSelf: 'stretch',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      gap: 12,
    },
    checkIconWrapper: {
      paddingTop: 2,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      gap: 8,
    },
    checkIcon: {
      width: 15,
      height: 15,
    },
    benefitText: {
      flex: '1 1 0',
      color: colours.neutral[600],
      fontSize: 14,
      fontFamily: 'Inter',
      fontWeight: 400,
      lineHeight: '20px',
      wordWrap: 'break-word',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(4),
    },
    previewCard: {
      border: `1px solid ${colours.neutral[200]}`,
      borderRadius: 8,
      display: 'flex',
      flexDirection: 'row',
      gap: spacing(1),
      overflow: 'hidden',
    },
    previewImageContainer: {
      width: 200,
      maxHeight: 190,
      height: '100%',
      position: 'relative',
    },
    previewImage: {
      width: 200,
      maxHeight: 190,
      height: '100%',
      objectFit: 'cover',
    },
    previewImagePlaceholder: {
      height: '100%',
      width: '100%',
      backgroundColor: colours.neutral[100],
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    previewImageIcon: {
      fontSize: 24,
      color: colours.neutral[400],
    },
    completedBadge: {
      position: 'absolute',
      top: spacing(2),
      left: spacing(2),
      backgroundColor: colours.solid.white,
      borderRadius: 6,
      padding: spacing(2),
      boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
      zIndex: 999,
      height: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    completedBadgeText: {
      color: colours.neutral[900],
      fontSize: 12,
      fontFamily: 'Inter',
      fontWeight: 600,
    },
    previewContentContainer: {
      flex: '1 1 auto',
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(1),
      overflow: 'hidden',
      padding: spacing(3),
    },
    previewTitleRow: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      justifyContent: 'center',
      width: '100%',
    },
    previewAddress: {
      color: colours.neutral[900],
      fontSize: 16,
      fontWeight: 600,
      lineHeight: '24px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '95%',
    },
    previewOrganisationInfo: {
      color: colours.neutral[600],
      fontWeight: 500,
      fontSize: 14,
      lineHeight: '20px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '95%',
    },
    previewDetails: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(2),
      marginTop: spacing(1),
    },
    previewDetailRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: spacing(2),
    },
    previewDetailIcon: {
      fontSize: 16,
      color: colours.neutral[600],
    },
    previewDetailText: {
      color: colours.neutral[900],
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: 500,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    previewTooltipContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    fieldToggleSection: {
      alignSelf: 'stretch',
      borderRadius: 8,
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(2),
      padding: spacing(2),
    },
    fieldToggleList: {},
    logoShareIcon: {
      alignSelf: 'stretch',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 24,
      display: 'inline-flex',
    },
    unpublishSection: {
      border: `1px solid ${colours.neutral[200]}`,
      borderRadius: 12,
      padding: spacing(1.5),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: spacing(3),
      backgroundColor: colours.solid.white,
    },
    unpublishHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: spacing(1),
      flex: 1,
    },
    unpublishIcon: {
      width: 16,
      height: 16,
      color: colours.neutral[500],
      flexShrink: 0,
    },
    unpublishText: {
      color: colours.neutral[600],
      fontSize: 14,
      fontFamily: 'Inter',
      fontWeight: 600,
      lineHeight: '20px',
    },
    unpublishButton: {
      height: 28,
      minWidth: 'auto',
      padding: `${spacing(0.75)}px ${spacing(1.5)}px`,
      borderColor: colours.neutral[300],
      color: colours.neutral[700],
      fontSize: 14,
      fontWeight: 500,
      flexShrink: 0,
      '&:hover': {
        borderColor: colours.neutral[400],
        backgroundColor: colours.neutral[100],
      },
    },
  });
